import { render, staticRenderFns } from "./EditItemDescription.vue?vue&type=template&id=04f3acad&scoped=true&"
import script from "./EditItemDescription.vue?vue&type=script&lang=ts&"
export * from "./EditItemDescription.vue?vue&type=script&lang=ts&"
import style0 from "./EditItemDescription.vue?vue&type=style&index=0&id=04f3acad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f3acad",
  null
  
)

export default component.exports